<template>
    <div class="c-a-textarea" :class="{'c-a-textarea--invalid': invalid}">
        <label class="c-a-textarea__label" :for="`question-${id}`">{{label}}<span v-if="required"> *</span></label>
        <textarea
            v-model="textValue"
            :id="`question-${id}`"
            :name="`question-${id}`"
            @input="updated"
            class="c-a-textarea__textarea"
            :placeholder="placeholder"
            rows="6"
        ></textarea>
    </div>
</template>

<script>
    export default {
        props:{
            id: Number,
            label: String,
            invalid: Boolean,
            required: Boolean,
            dataKey: String,
            placeholder: String
        },
        data(){
            return {
                textValue: ''
            }
        },
        methods:{
            updated(){
                const data = {
                    questionId: this.id,
                    label: this.label,
                    answers: this.textValue,
                    text:true
                };

                if(this.dataKey){
                    data.dataKey = this.dataKey;
                }

                this.$emit('updateData', data);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/request-form/AtomTextareaRequestForm.vue